import { classes, createMap, react } from "../../../omnia"
import { PlanContext } from "../../context"

interface Props {
    selectedFieldId?: number
    disableUi: boolean
}

export function FieldSelector({ selectedFieldId, disableUi }: Props) {

    const { api, dispatch } = React.useContext(PlanContext)
    const { fields } = api

    const { fieldsMap, ids } = React.useMemo(() => {
        const fieldsMap = createMap(fields, f => f.fieldId)
        const ids = [...fieldsMap.keys()]
        return { fieldsMap, ids }
    }, [fields])

    const [queryText, setQueryText] = React.useState("")

    const selectField = (id: number) => dispatch({ type: "selectField", selectedFieldId: id })

    const selectUsingTypeahead = fields.length >= 30

    const placeholder = "(Select a field)"

    if (!selectUsingTypeahead) {

        return <select
            className={classes("form-control", (!selectedFieldId) && "placeholder")}
            value={selectedFieldId ?? 0}
            disabled={disableUi}
            onChange={e => selectField(Number(e.target.value))}>
            <option value={0} className="placeholder">{placeholder}</option>
            {fields.map(f =>
                <option key={f.fieldId} value={f.fieldId}>{f.description}</option>
            )}
        </select>

    }

    return <react.Typeahead2
        source={{ items: ids }}
        keySelector={id => id}
        textSelector={id => fieldsMap.get(id)?.description}
        selected={selectedFieldId}
        setSelected={selectField}
        text={queryText}
        setText={setQueryText}
        maxHeight={{ vh: 50 }}
        placeholder={placeholder}
        inputCssClass={classes("form-control", (!selectedFieldId) && "placeholder")}
    />

}
